// extracted by css-extract-rspack-plugin
export default {"productListCounter":"product-listing-fragment__ProductListCounter_productListCounter__Ta0Tw","count":"product-listing-fragment__ProductListCounter_count__ZVuw3"};